import React from "react";
import Header from "./Header";
import TopBar from "./TopBar";
import OurStory from "./OurStory";
import FoodMenu from "./FoodMenu";
import Reviews from "./Reviews";
import InstagramGallery from "./InstagramGallery";
import Location from "./Location";
import useTopBarData from '../hooks/useTopBarData';
import usePageMeta from '../hooks/usePageMeta';

// Keep in sync with the <title> and description in public/index.html.
export const HOME_TITLE = "Bobbie Sue's Mac + Cheese | Toronto Mac & Cheese on Ossington";
export const HOME_DESCRIPTION = "Craving mac and cheese in Toronto? Visit Bobbie Sue's on Ossington for creamy five-cheese mac, pulled pork, BBQ chicken and vegan options. See our menu and order now.";

const Home = (props) => {
  const topBarData = useTopBarData();

  usePageMeta({
    title: HOME_TITLE,
    description: HOME_DESCRIPTION,
    canonical: "https://bobbiesues.ca/"
  });

  return (
      <>
        <TopBar navShrink={props.navShrink} topBarData={topBarData} />
        <main>
        <div id="headerSection" ref={topBarData[0].headerRef}><Header  /></div>
        <div id="ourStorySection" ref={topBarData[1].headerRef}><OurStory /></div>
        <div id="foodMenuSection" ref={topBarData[2].headerRef}><FoodMenu  /></div>
        <Reviews />
        <InstagramGallery />
        <div id="locationSection" ref={topBarData[3].headerRef}><Location /></div>
        </main>
      </>
    );
}

export default Home;
